var map = {
	"./AboutView.vue": [
		8162,
		741,
		242,
		634,
		371
	],
	"./ApiView.vue": [
		4051,
		51
	],
	"./BlockChainsView.vue": [
		6866,
		866
	],
	"./CreditAnalysisView.vue": [
		9549,
		549
	],
	"./CreditEvaluateView.vue": [
		8873,
		873
	],
	"./CultureDetailView.vue": [
		5793,
		741,
		128
	],
	"./CultureView.vue": [
		6283,
		741,
		242,
		586,
		283
	],
	"./DemoView.vue": [
		5195,
		741,
		357
	],
	"./DigitalBrain.vue": [
		5985,
		985
	],
	"./DigitalInvestmentView.vue": [
		4339,
		288,
		614
	],
	"./HomeView.vue": [
		3839,
		288,
		963
	],
	"./JoinUsView.vue": [
		7794,
		741,
		242,
		586,
		634,
		899
	],
	"./NewsDetailView.vue": [
		7307,
		741,
		784
	],
	"./NewsView.vue": [
		9630,
		741,
		242,
		586,
		630
	],
	"./PolicyServicesView.vue": [
		6606,
		606
	],
	"./ProductView.vue": [
		2431,
		431
	],
	"./PsSearchNewView.vue": [
		7111,
		111
	],
	"./SmallEntServeView.vue": [
		2210,
		288,
		673
	],
	"./SupplyChainsView.vue": [
		1049,
		49
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4127;
module.exports = webpackAsyncContext;